import { catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";
import { startOfMonth } from "services/DateService";
import { MSystemGet } from "../common";
import { PageableResponse } from "../PageableResponse";

// 当月取得処理
export const B010020TogetsuYm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  await MSystemGet()
    .then((response) => {
      const firstYmd = startOfMonth(response.data.togetsuYm);
      // 受注日の範囲(開始)初期設定
      methods.setValue("juchuYmdFrom", firstYmd);
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("juchuYmdFrom", "");
    });
};

export type B010020FindRequest = Partial<{
  juchuYmdFrom: string;
  juchuYmdTo: string;
  seisakuYmdFrom: string;
  seisakuYmdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  tokuiCd: string;
  tokuishitenCd: string;
  juchuStatus: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  nohinyoteiYmdFrom: string;
  nohinyoteiYmdTo: string;
  eigyoCdFrom: string;
  eigyoCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  chumonNo: string;
  nonyuCd: string;
  nonyushitenCd: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B010020FindResponse = {
  juchuYmd: string;
  juchudenpyoNo: string;
  juchuKbn: string;
  tokuiNm: string;
  nohinyoteiYmd: string;
  shainNm: string;
  juchuKin: string;
  bumonNm: string;
  arariKin: string;
  shukakakuteiKin: string;
  juchuStatus: string;
};

// 検索メソッド
export const B010020Find = (props: B010020FindRequest) => {
  return RestClient.get<PageableResponse<B010020FindResponse[]>>(
    "b010020/find",
    {
      params: props,
    }
  );
};

export type B010020GetRequest = {
  juchudenpyoNo: string | undefined;
};

export type B010020GetResponse = {
  juchuKbn: string;
  juchudenpyoNo: string;
  juchuYmd: string;
  nohinyoteiYmd: string;
  tokuiShokuchiKbn: string;
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
  tankaKakeritsu: string;
  zeimarumeKbn: string;
  kinmarumeKbn: string;
  tokuiPostCd: string;
  tokuiAddress1: string;
  tokuiAddress2: string;
  tokuiTelNo: string;
  tokuiFaxNo: string;
  nonyuShokuchiKbn: string;
  nonyuCd: string;
  nonyushitenCd: string;
  nonyuNm: string;
  nonyuPostCd: string;
  nonyuAddress1: string;
  nonyuAddress2: string;
  nonyuTelNo: string;
  nonyuFaxNo: string;
  ediMemo: string;
  shainCd: string;
  shainNm: string;
  eigyoCd: string;
  seisakuYmd: string;
  shukayoteiYmd: string;
  jisanYmd: string;
  denpyoYmd: string;
  shimeD: string;
  chohaKbn: string;
  hasosakiCd: string;
  hasosakiNm: string;
  hasokbnCd: string;
  hasokbnNm: string;
  zeiKbn: string;
  assistantCd: string;
  assistantNm: string;
  denpyoshubetsuCd: string;
  denpyoshubetsuNm: string;
  tenpudenpyoCd: string;
  tenpudenpyoNm: string;
  bunrui: string;
  unsogaishaCd: string;
  unsogaishaNm: string;
  bumonCd: string;
  bumonNm: string;
  ppgakeKbn: string;
  netsukeKbn: string;
  chumonNo: string;
  denpyoKbn: string;
  ritsu: string;
  hinbetsuNo: string;
  tantosha: string;
  bikoCd: string;
  biko: string;
  nohinsaki: string;
  lineCd: string;
  lineNm: string;
  uribaNm: string;
  naisen: string;
  zeiRitsu: string;
  jodaihyojiKbn: string;
  tankamarumeKbn: string;
  tankahasuichi: string;
  ediJuchuNo: string;
  version: string;
  b010020GetMeiResponse: B010020GetJuchuMei[];
};

type B010020GetJuchuMei = {
  juchugyoNo: string;
  uchiwakeKbn: string;
  shohinCd: string;
  janCd: string;
  shohinNm: string;
  aiteCd: string;
  sokoCd: string;
  sokoNm: string;
  vol: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  juchusu: string;
  kanosu: string;
  tenyuryokujodaiKbn: string;
  tenyuryokujuchuKbn: string;
  jodaitanka: string;
  juchutanka: string;
  setJodaitanka: string;
  toritankaJodaitanka: string;
  toritankaTanka: string;
  tankaTanka: string;
  whJodaitanka: string;
  kakeritsu: string;
  juchuKin: string;
  meisaibikoCd: string;
  meisaibiko: string;
  kazeiKbn: string;
  setshohinKbn: string;
  edishohinNm: string;
  crtDate: string;
  crtshainCd: string;
  shohinshubetsuKbn: string;
  tankaKbn: string;
  shokuchiKbn: string;
  whtankaCd: string;
  sokoshubetsuKbn: string;
  zairyohikiatesu: string;
  zairyohikiateKanoNagasa: string;
  zairyohikiateNagasa: string;
  b010020GetMeiKoseiResponse: B010020GetJuchuMeiKosei[];
};

type B010020GetJuchuMeiKosei = {
  juchugyoNo: string;
  juchukoseigyoNo: string;
  shohinCd: string;
  janCd: string;
  shohinNm: string;
  aiteCd: string;
  sokoCd: string;
  sokoNm: string;
  vol: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  hitsuyosu: string;
  koseisu: string;
  kanosu: string;
  tenyuryokujodaiKbn: string;
  tenyuryokujuchuKbn: string;
  jodaitanka: string;
  juchutanka: string;
  setJodaitanka: string;
  toritankaJodaitanka: string;
  toritankaTanka: string;
  tankaTanka: string;
  whJodaitanka: string;
  kakeritsu: string;
  juchuKin: string;
  meisaikoseiBikoCd: string;
  meisaikoseiBiko: string;
  kazeiKbn: string;
  shohinshubetsuKbn: string;
  tankaKbn: string;
  shokuchiKbn: string;
  whtankaCd: string;
  sokoshubetsuKbn: string;
  zairyohikiatesu: string;
  zairyohikiateKanoNagasa: string;
  zairyohikiateNagasa: string;
  crtDate: string;
  crtshainCd: string;
};

// 受注データ取得メソッド
export const B010020Get = (props: B010020GetRequest) => {
  return RestClient.get<B010020GetResponse>("b010020/get", {
    params: props,
  });
};

export type B010020GetCopyRequest = {
  juchudenpyoNo: string | undefined;
  copyKbn: string;
};

// 受注データ取得複製メソッド
export const B010020GetCopy = (props: B010020GetCopyRequest) => {
  return RestClient.get<B010020GetResponse>("b010020/get/copy", {
    params: props,
  });
};

export type B010020JuchudenpyoNo = Partial<{
  juchudenpyoNo: string;
  version: number;
}>;

export type B010020UpdateRequest = {
  b010020UpdateFiledList: B010020JuchudenpyoNo[];
};

// 受注キャンセルメソッド
export const B010020Update = (props: B010020UpdateRequest) => {
  return RestClient.put("b010020/update", props);
};
